import React from 'react';
import { DjayAvatar, type DjayEmotion } from '../../mascot';
import { Button } from '../ui/Button';
interface EmptyStateProps {
  title: string;
  message: string;
  emotion?: DjayEmotion;
  actionLabel?: string;
  onAction?: () => void;
  colorScheme?: 'emerald' | 'indigo' | 'slate';
}
const colorMap = {
  emerald: 'bg-emerald-50 border-emerald-100',
  indigo: 'bg-indigo-50 border-indigo-100',
  slate: 'bg-slate-50 border-slate-100'
} as const;
const buttonVariantMap = {
  emerald: 'primary' as const,
  indigo: 'primary' as const,
  slate: 'secondary' as const
};
export function EmptyState({
  title,
  message,
  emotion = 'happy',
  actionLabel,
  onAction,
  colorScheme = 'slate'
}: EmptyStateProps) {
  return <div className="flex flex-col items-center justify-center py-12 px-6" data-id="element-1987">
      <div className={`rounded-2xl border p-8 flex flex-col items-center text-center max-w-sm ${colorMap[colorScheme]}`} data-id="element-1988">
        <div className="mb-4" data-id="element-1989">
          <DjayAvatar size="lg" emotion={emotion} data-id="element-1990" />
        </div>
        <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1991">{title}</h3>
        <p className="text-sm text-slate-500 leading-relaxed" data-id="element-1992">{message}</p>
        {actionLabel && onAction && <div className="mt-5" data-id="element-1993">
            <Button variant={buttonVariantMap[colorScheme]} size="sm" onClick={onAction} data-id="element-1994">
              {actionLabel}
            </Button>
          </div>}
      </div>
    </div>;
}